'use client';

import React, { FC, JSX } from 'react';
import dynamic from 'next/dynamic';
import IsScrolledWrapper from '@/components/lazyWrapper/IsScrolledWrapper';

const DeferredCss = dynamic(() => import('@/components/deferredCss/DeferredCss'), { ssr: false });

const DeferredCssWrapper: FC<{ renderImmediately?: boolean }> = ({
  renderImmediately
}): JSX.Element => {
  return renderImmediately ? (
    <DeferredCss />
  ) : (
    <IsScrolledWrapper>
      <DeferredCss />
    </IsScrolledWrapper>
  );
};

export default DeferredCssWrapper;
